export default {"src":"/_next/static/media/instagram.d38f5c21.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};